import { render, staticRenderFns } from "./userRole.vue?vue&type=template&id=1fc6e697&scoped=true"
import script from "./userRole.vue?vue&type=script&lang=js"
export * from "./userRole.vue?vue&type=script&lang=js"
import style0 from "./userRole.vue?vue&type=style&index=0&id=1fc6e697&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc6e697",
  null
  
)

export default component.exports